var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import useStyle from './CircularProgressBarStyles';
var CircularProgressBar = function (_a) {
    var children = _a.children, _b = _a.progress, progress = _b === void 0 ? 0 : _b;
    var _c = useStyle(), circle = _c.circle, wrapper = _c.wrapper;
    var radius = 18;
    var stroke = 2;
    var normalizedRadius = radius - stroke * 2;
    var circumference = normalizedRadius * 2 * Math.PI;
    var strokeDashoffset = circumference - (-progress * circumference) / 100;
    return (_jsx("div", __assign({ css: wrapper }, { children: _jsxs("svg", __assign({ height: 30, width: 30 }, { children: [_jsx("circle", { css: circle, style: { strokeDashoffset: strokeDashoffset }, strokeWidth: stroke, strokeDasharray: circumference, r: normalizedRadius, cx: 15, cy: 15 }, void 0),
                _jsx("foreignObject", __assign({ x: "3", y: "3", width: "100%", height: "100%" }, { children: children }), void 0)] }), void 0) }), void 0));
};
export default CircularProgressBar;
